import { CssType } from 'src/theme/jss-types';

export const AddUserDrawerStyles = (): CssType => ({
  drawerContent: {
    padding: 16,
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: 8,
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 16,
    '& button:first-child': {
      marginRight: 8,
    },
  },
});

export default AddUserDrawerStyles;
